import types from '../types/modal';

export const showModal = name => dispatch => (
  dispatch({ type: types.MODAL_SHOW, payload: name })
);

export const hideModal = name => dispatch => (
  dispatch({ type: types.MODAL_HIDE, payload: name })
);
